import { Component, EventEmitter, Input, OnInit, Output, ViewChild  } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { CqExtraParamsDestination } from 'src/app/beans/components/cq-extra-params/cq-extra-params-destination.bean';
import { CqFileDestination } from 'src/app/beans/components/cq-file/cq-file-destination.bean';
import { CustomValidator } from 'src/app/beans/errors/custom-validator.bean';
import { User                      } from 'src/app/beans/login/user/user.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { Place } from 'src/app/beans/place/place.bean';
import { Site                      } from 'src/app/beans/site/site.bean';
import { SiteDetail                } from 'src/app/beans/site/site.detail';
import { GenericDialog             } from 'src/app/dialogs/generic/generic.dialog';
import { QuickSiteDialog } from 'src/app/dialogs/quick-site/quick-site.dialog';
import { StepperDialog } from 'src/app/dialogs/stepper/stepper.dialog';
import { AuthLevel } from 'src/app/enums/auth/auth.enum';
import { DialogsReturnCode         } from 'src/app/enums/dialogs/returnCode.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { HandlerManager            } from 'src/app/managers/handler/handler.manager';
import { LoadingManager            } from 'src/app/managers/loading/loading.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { SessionManager            } from 'src/app/managers/session/session.manager';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { extensionMatch } from 'src/app/validators/extension.validator';
import { genericValidator } from 'src/app/validators/generic.validator';
import { PlaceAutocomplete } from '../../autocomplete/place/place.autocomplete';

@Component
({
  selector: 'site-data-container',
  templateUrl: './site.data.container.html',
  styleUrls: ['./site.data.container.scss']
})

export class SiteDataContainer implements OnInit 
{
  public _site_detail: SiteDetail
  savedSiteDetail: SiteDetail = null

  private org: Organization
  public hasQuickSite: boolean = false

  advanced: boolean = false

  @ViewChild('autocompleteManager') placeManager: PlaceAutocomplete;

  @Input('org') set _org(org: Organization)
  {    
    this.org = org
  }

  siteId: number 
  @Input('site') set _site(site: Site)
  {    
    if(!site) return 
    this.siteId = site.id
    this.hasSiteQuick()
    this.init(this.siteId)

  }

  showHelp: boolean = false
  operation: string = "create"

  @Output('refresh') refresh: EventEmitter<void> = new EventEmitter()
  
  constructor
  (
    private _handler  : HandlerManager  ,
    private _loader   : LoadingManager  ,
    private _session  : SessionManager  ,
    private _dialog   : MatDialog       ,
    private _utils    : UtilsManager    ,
    private _notifier : NotifierManager
  ) {}

  //-------------------------------------------------------------------------

  ngOnInit(): void 
  {
    this._site_detail = new SiteDetail()
  }

  async init( siteId: number)
  {
    if(siteId)
    {
      this._site_detail = await this.retriveValues(siteId)
      if(this._site_detail) this.operation = "update"
    }
  }

  async hasSiteQuick(){

    let user = this._session.user().get()

    if( !User.isKind( user )) return 

    user = user as User

    const dest: CqExtraParamsDestination = {
      codes   : [ 
        "QCREATE_SITE"
      ],
      level   : "SI",
      type    : "WAPP",
      levelid : this.siteId
    }

    const resp = await this._handler.extraParams().getParamByCode(user.token, dest)
    if(!resp) return 

    this.hasQuickSite= resp.value1 == "1"
  }

  //-------------------------------------------------------------------------
  isQuickCreateEnabled(){
    const user = this._session.user().get() as User

    if(user && !isSessionCode(user))
    {
      return  (     user.level == AuthLevel.HUB_MANAGER
                ||  user.level == AuthLevel.ORG_MANAGER   )
              &&    this.hasQuickSite
    }

    return false

  }


  //-------------------------------------------------------------------------

  placeChanged(event: Place) 
  {
    this._site_detail.placeId   = event.id
    this._site_detail.placeName = event.name
  }

  create()
  {
    this.saveSiteData()

    this._site_detail = new SiteDetail()
    this._site_detail.enabled = 1
    
    this.placeManager.clear();

    this.operation = "create"
  }

  quick()
  {
    if(!this.isValidDetail() ) return 

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;
    dialogConfig.data = {
      orgId: this.org.id ,
      siteData: this._site_detail
    }

    let dialog = this._dialog.open(QuickSiteDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data) =>
    {
      if(data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        this.refresh.emit()
      }
    })
  
  }

  update()
  {
    if(!this.isValidDetail() ) return 

    this._site_detail.enabled = this._site_detail.enabled ? 1 : 0
  
    this.openDialog()
  }

  cancel()
  {
    this._site_detail = this.savedSiteDetail
    this.operation = "update"
    this.placeManager.reselect()
  }

  saveSiteData()
  {
    this.savedSiteDetail = new SiteDetail()
    this.savedSiteDetail.id             = this._site_detail.id
    this.savedSiteDetail.name           = this._site_detail.name
    this.savedSiteDetail.siteCode       = this._site_detail.siteCode
    this.savedSiteDetail.type           = this._site_detail.type
    this.savedSiteDetail.placeId        = this._site_detail.placeId
    this.savedSiteDetail.placeName      = this._site_detail.placeName
    this.savedSiteDetail.latitude       = this._site_detail.latitude
    this.savedSiteDetail.longitude      = this._site_detail.longitude
    this.savedSiteDetail.address        = this._site_detail.address
    this.savedSiteDetail.zipCode        = this._site_detail.zipCode
    this.savedSiteDetail.phone          = this._site_detail.phone
    this.savedSiteDetail.email          = this._site_detail.email
    this.savedSiteDetail.monNotifyEmail = this._site_detail.monNotifyEmail
    this.savedSiteDetail.sessionTime    = this._site_detail.sessionTime
    this.savedSiteDetail.enabled        = this._site_detail.enabled
  }

  openDialog()
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog = this._dialog.open(GenericDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data) =>
    {
      if(data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        if     (this.operation == "update") await this.updateSite()
        else if(this.operation == "create") await this.createSite()
        
        this.refresh.emit()
        //if(this.operation == "create") await this.retriveValues( this._site_detail.id )
      }
    })
  }

  //-------------------------------------------------------------------------

  async retriveValues( siteId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.site().detail((user as User).token, siteId)

    this._loader.stop()

    if ( !response        ) return
    if ( !response.object ) return

    return response.object as SiteDetail;
  }

  async createSite() 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.site().create((user as User).token, this.org.id, this._site_detail)

    this._loader.stop()
  }

  async updateSite() 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.site().update((user as User).token, this._site_detail)

    this._loader.stop()
  }

  getDest(): CqFileDestination
  {
    if(!this.siteId) return null
    return {
      level       : "SI",
      levelid     : this.siteId ,
      type        : "WAPP",
      code        : "LOGO"
    }
  }

  isValidDetail(){

    if (!this._utils.checker().isValidText(this._site_detail.name)) 
    {
      this._notifier.show( 
        Notifier.WARNING, 
        NotifierMessage.INVALID_SITE_NAME
      )
      return false
    }

    if (!this._utils.checker().isValidId(this._site_detail.zipCode)) 
    {
      this._notifier.show( 
        Notifier.WARNING, 
        NotifierMessage.INVALID_SITE_ZIPCODE
      )
      return false
    }

    if (!this._utils.checker().isValidText(this._site_detail.address)) 
    {
      this._notifier.show( 
        Notifier.WARNING, 
        NotifierMessage.INVALID_SITE_ADDRESS
      )
      return false
    }

    if (!this._utils.checker().isValidId(this._site_detail.latitude)) 
    {
      this._notifier.show( 
        Notifier.WARNING, 
        NotifierMessage.INVALID_SITE_LATITUDE
      )
      return false
    }

    if (!this._utils.checker().isValidId(this._site_detail.longitude)) 
    {
      this._notifier.show( 
        Notifier.WARNING, 
        NotifierMessage.INVALID_SITE_LONGITUDE
      )
      return false
    }

    if (!this._utils.checker().isValidId(this._site_detail.placeId)) 
    {
      this._notifier.show( 
        Notifier.WARNING, 
        NotifierMessage.INVALID_SITE_PLACE_ID
      )
      return false
    }

    return true
  }

  isInState(state: string){
    return this.operation == state
  }

}
